import React from "react";
import { useRouter } from "next/router";
import { func, bool } from "prop-types";

import PreconfigurationList from "../PreconfigurationPicker/PreconfigurationList";
import PriceDetail from "@components/PriceDetail/PriceDetail";
import CompareButtonContainer from "@components/CompareButtonContainer/CompareButtonContainer";
import CollapsableContainerPreconfigurations from "./CollapsableContainerPreconfigurations";

import { useDetectDevice } from "@hooks/useDetectDevice";
import { useGetPriceDetailProps } from "@hooks/useGetPriceDetailProps";
import { useIsCashJourneySelected } from "@hooks/useIsCashJourneySelected";
import { useCurrencySettingsSelector } from "@redux/reducers/appConfig";
import { useSelectedJourneySelector } from "@redux/reducers/deal";
import { ROUTES } from "@shared/routing/routes";
import { FIXED_ELEMENTS_ATTRIBUTE_NAME } from "@hooks/useScrollToView";
import { useCashVehiclePrice } from "../../hooks/useCashVehiclePrice";

const CarouselAndFinanceBar = ({
  onIsFinancingOpenChange,
  isPromoCodeApplicable,
}) => {
  const isCashJourneySelected = useIsCashJourneySelected();

  const journey = useSelectedJourneySelector();

  const currencySettings = useCurrencySettingsSelector();

  const router = useRouter();

  const { isDesktop } = useDetectDevice();

  const containerAttributes = {
    [FIXED_ELEMENTS_ATTRIBUTE_NAME]: router.pathname === ROUTES.CONFIG,
  };

  const {
    amount,
    isLeasingRequestLoading,
    isFinanceRequestError,
    withFinanceWidgetButton,
    withEcoBonus,
    deposit,
    teaser,
    isPersonalisedVACOffer,
  } = useGetPriceDetailProps(isPromoCodeApplicable);

  const total = useCashVehiclePrice(isPromoCodeApplicable);

  return (
    <div
      className="flex w-full mx-auto bg-primaryDark/95 backdrop-blur-lg md:max-lg:rounded-t-md"
      {...containerAttributes}
    >
      <div className="flex space-between m-0 mx-auto w-full max-w-pageContent">
        {isDesktop && (
          <div className="hidden flex-1-1-0 lg:flex">
            <CollapsableContainerPreconfigurations>
              {({ isOpen }) => (
                <>
                  <PreconfigurationList isOpen={isOpen} />
                  <CompareButtonContainer />
                </>
              )}
            </CollapsableContainerPreconfigurations>
          </div>
        )}
        <PriceDetail
          className="w-full lg:w-152 py-0"
          amount={amount}
          currencySymbol={currencySettings.symbol}
          deposit={deposit}
          isFinanceRequestError={isFinanceRequestError}
          isLoading={isLeasingRequestLoading}
          isPersonalisedVACOffer={isPersonalisedVACOffer}
          isQuantityVisible={false}
          journey={journey}
          onIsFinancingOpenChange={onIsFinancingOpenChange}
          priceFormat={currencySettings.format}
          teaser={teaser}
          total={total}
          withDeliveryInfo
          withEcoBonus={withEcoBonus}
          withFinanceWidgetButton={withFinanceWidgetButton}
          withJourneySwitch
          withParallelograms={isCashJourneySelected}
        />
      </div>
    </div>
  );
};

CarouselAndFinanceBar.propTypes = {
  onIsFinancingOpenChange: func.isRequired,
  isPromoCodeApplicable: bool,
};

export default CarouselAndFinanceBar;
